import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { Form } from "react-bootstrap";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { useNoticeManager } from "../hooks/useNoticeManager";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpRightFromSquare, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import "./EventNotices.css";
type NoticeData = [string];

interface EventNoticesProps {
	initialData: NoticeData;
	onValueChange: (data: string[]) => void;
}

export const EventNotices: React.FC<EventNoticesProps> = ({
	initialData,
	onValueChange,
}) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { getData, notices, noticesLoaded } = useNoticeManager();
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const [linkedNotices, setLinkedNotices] = useState<any>([]);
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const [noticeArray, setNoticeArray] = useState<any>([]);
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [selectedNotice, setSelectedNotice] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const [options, setOptions] = useState<any>([]);

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleNoticeCombo = (e: any) => {
		console.log("Notice chosen: ", e);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		setNoticeArray((n: any) => [...n, e[0].id]);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		setLinkedNotices((n: any) => [...n, e[0]]);
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleRemoveNotice = (notice: any) => {
		let newNoticeArray = linkedNotices.filter(
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			(item: any) => item.id !== notice.id
		);
		setNoticeArray(newNoticeArray);
		setLinkedNotices(newNoticeArray);
	};

	const handleSearch = async (query: string) => {
		setIsLoading(true);
		const result = await getData(query);
		if (result) {
			let optionsArray = result
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				.map((item: any) => {
					if (item.ApprovalStatus === "approved") {
						let date = new Date(item.Date).toLocaleDateString("en-us", {
							weekday: "long",
							year: "numeric",
							month: "short",
							day: "numeric",
						});
						return {
							id: item._id,
							name: item.Title,
							Title: item.Title,
							Date: date,
							Summary: item.Summary,
							Banner: item.MainImage,
						};
					} else return null;
				})
				.filter(Boolean);
			setOptions(optionsArray);
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if (initialData) {
			console.log("Initial Data:", initialData);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			let linkedNoticesArray = initialData.map((item: any) => {
				if (typeof item !== "string") {
					let date = new Date(item.Date).toLocaleDateString("en-us", {
						weekday: "long",
						year: "numeric",
						month: "short",
						day: "numeric",
					});
					return {
						id: item._id,
						Title: item.Title,
						Date: date,
						Summary: item.Summary,
						Banner: item.MainImage,
					};
				}
			});
			// let noticeIdArray = initialData.map((item: any) => {
			// 	return item._id;
			// });
			setLinkedNotices(linkedNoticesArray);
			//setNoticeArray(noticeIdArray);
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		onValueChange(linkedNotices);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [linkedNotices]);

	// Bypass client-side filtering by returning `true`. Results are already
	// filtered by the search endpoint, so no need to do it again.
	const filterBy = () => true;

	return (
		<Container>
			<Row className="mb-3">
				<Col className="col-md-12">
					<h3>Linked Notices</h3>
				</Col>
			</Row>

			<Row className="col-md-3 mb-5">
				<Col className="col-md-12">
					<Form.Label>Find a notice:</Form.Label>
					<AsyncTypeahead
						filterBy={filterBy}
						id="search-notices"
						isLoading={isLoading}
						labelKey="name"
						minLength={2}
						onSearch={handleSearch}
						options={options}
						onChange={handleNoticeCombo}
						selected={selectedNotice}
					/>
					<Form.Control
						type="hidden"
						id="linkedNotices"
						className="col-md-12"
						value={noticeArray}
					/>
				</Col>
			</Row>
			<Row className="mb-3">
				{linkedNotices.length > 0 &&
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					linkedNotices.map((notice: any) => (
						<Col className="col-md-3 mb-3" key={notice.id}>
							<Card>
								{notice.Banner && (
									<Card.Img variant="top" src={notice.Banner} />
								)}
								<Card.Body>
									<Card.Title>{notice.Title}</Card.Title>
									<Card.Subtitle className="mb-2 text-muted">
										{notice.Date}
									</Card.Subtitle>
									<Card.Text>{notice.Summary}</Card.Text>
								</Card.Body>
								<Card.Footer className="text-right">
									<Card.Link
										target="_blank"
										href={
											"https://notices.pymblelc.nsw.edu.au/notices?_id=" +
											notice.id
										}
										className="mr-2"
									>
										See Notice
									</Card.Link>
									&nbsp;
									<FontAwesomeIcon
										className="fa-sm"
										icon={faUpRightFromSquare}
									/>
									<FontAwesomeIcon
										className="float-right"
										icon={faCircleXmark}
										title="Remove notice"
										onClick={() => handleRemoveNotice(notice)}
									/>
								</Card.Footer>
							</Card>
						</Col>
					))}
			</Row>
		</Container>
	);
};
